import { render, staticRenderFns } from "./adminMenuManage.vue?vue&type=template&id=166a5548&scoped=true"
import script from "./adminMenuManage.vue?vue&type=script&lang=js"
export * from "./adminMenuManage.vue?vue&type=script&lang=js"
import style0 from "./adminMenuManage.vue?vue&type=style&index=0&id=166a5548&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166a5548",
  null
  
)

export default component.exports